var map = {
	"./add-quick-message.svg": 713877,
	"./add-white.svg": 876213,
	"./add.svg": 427489,
	"./api-bg.svg": 88072,
	"./attachFileSVG.svg": 678797,
	"./blueticks-logo.svg": 32514,
	"./blueticks/favicon.ico": 422502,
	"./blueticks/logo.svg": 637916,
	"./blueticks/logo_clean.svg": 361326,
	"./blueticks/logowithtext.png": 888393,
	"./card-three-digits.png": 351122,
	"./digital-clock.svg": 162353,
	"./email-confirmation.png": 591974,
	"./enterprise.png": 316541,
	"./expandGantt.svg": 255642,
	"./focusIcon.svg": 429283,
	"./forbidden-access-view-background.png": 581789,
	"./free2.png": 105354,
	"./icons/account.png": 947831,
	"./icons/backPageArrow.png": 548446,
	"./icons/bell.png": 59262,
	"./icons/closeBillingModal.png": 622861,
	"./icons/copyIcon.png": 342961,
	"./icons/dashboard.png": 708925,
	"./icons/dateSelectMenu.png": 636600,
	"./icons/firstDateOptionColumn.png": 198374,
	"./icons/groupedIcon.png": 443916,
	"./icons/info.png": 49469,
	"./icons/invite.png": 857370,
	"./icons/lastDateOptionColumn.png": 690084,
	"./icons/logout.png": 469263,
	"./icons/newWorkspace.png": 598584,
	"./icons/replaceImg.png": 85828,
	"./icons/security.png": 501543,
	"./icons/ungroupedIcon.png": 854599,
	"./icons/upgrade.png": 396413,
	"./icons/workspace.png": 575690,
	"./icons/world.png": 733681,
	"./llm-logos/claude-color.svg": 612377,
	"./llm-logos/gemini-color.svg": 856254,
	"./llm-logos/openai.svg": 602067,
	"./locked-free-plan.svg": 470615,
	"./locked-premium-plan.svg": 384406,
	"./logo.png": 49405,
	"./logowithtext.png": 404612,
	"./new-task.svg": 329000,
	"./notasks.png": 755479,
	"./pipelbizIcon.png": 429368,
	"./pngrocket.png": 935183,
	"./shield2.png": 395017,
	"./small-link.svg": 314018,
	"./tudo_logo.svg": 881052,
	"./tudo_logo_clean.png": 276528,
	"./tudoboard/favicon.ico": 779886,
	"./tudoboard/logo.svg": 484532,
	"./tudoboard/logo_clean.svg": 491254,
	"./two-ticks.svg": 838271,
	"./unavailable.png": 867896,
	"./visa.png": 386939,
	"./waChannel.svg": 84141,
	"./waGroup.svg": 917501,
	"./waPerson.svg": 296291,
	"./wa_bg_bright.jpg": 92501,
	"./wa_bg_dark.jpg": 666065,
	"./whatsapp-api-webhook-guide-step1.jpg": 24010,
	"./whatsapp-api-webhook-guide-step2.jpg": 650261,
	"./whatsapp-api-webhook-guide-step3.jpg": 526040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 544729;